import { loginRequest } from "authConfig/authConfig";
import { msalInstance } from "authConfig/msalInstance";
import axios from "axios";
import endpointsConfig from "endpoints.config";
import store from "redux/store/store"; //  IMPORT STORE

const axiosInstance = axios.create({
  baseURL: endpointsConfig.UserBaseUrl,
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use(async (config) => {
  //  Get MSAL token
  const account = msalInstance.getActiveAccount();

  if (account) {
    const response = await msalInstance.acquireTokenSilent({
      ...loginRequest,
      account,
    });

    config.headers.Authorization = `Bearer ${response.accessToken}`;
  }

  // Only add selected gateway header if not already set
  if (!config.headers["gatewayId"]) {
    const state = store.getState();
    const selectedGateway = state.gateway.selectedGateway;

    if (selectedGateway?.id) {
      config.headers["gatewayId"] = selectedGateway.id;
    }
  }

  return config;
});

export default axiosInstance;
